var map = {
	"./function/qrcode/locales.ts": 62064,
	"./function/reseturl/locales.ts": 83574,
	"./index/locales.ts": 96971,
	"./lenovoid/bindmobile/locales.ts": 52798,
	"./loginout/locales.ts": 75105,
	"./middlepage/lexiang/locales.ts": 54281,
	"./middlepage/live/locales.ts": 96736,
	"./middlepage/shop/locales.ts": 74523,
	"./middlepage/upstream/locales.ts": 30465,
	"./middlepage/yxt/locales.ts": 69469,
	"./oauth2/authorize/locales.ts": 54020,
	"./personal/bindmobile/locales.ts": 25391,
	"./personal/bindwechat/index/locales.ts": 31663,
	"./personal/bindwechat/qrcode/locales.ts": 2517,
	"./personal/changemobile/locales.ts": 52395,
	"./personal/editpwd/locales.ts": 36271,
	"./personal/forgetpwd/locales.ts": 86154,
	"./personal/index/locales.ts": 53424,
	"./personal/lowresetpsd/locales.ts": 16778,
	"./personal/resetpwd/locales.ts": 6119,
	"./register/activation/locales.ts": 35636,
	"./register/bindmobile/locales.ts": 60602,
	"./register/index/locales.ts": 52494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91116;